import { render, staticRenderFns } from "./ServiceNumberDetailPrint.vue?vue&type=template&id=03975536&scoped=true&"
import script from "./ServiceNumberDetailPrint.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberDetailPrint.vue?vue&type=script&lang=js&"
import style0 from "./ServiceNumberDetailPrint.vue?vue&type=style&index=0&id=03975536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03975536",
  null
  
)

export default component.exports